import React from 'react';
import Icon from '../AppIcon';

const HeaderBrand = () => {
  return (
    <header className="header-brand">
      <div className="header-brand-logo">
        <Icon name="Phone" size={32} color="#FFFFFF" strokeWidth={2.5} />
      </div>
      <div className="header-brand-text">
        <h1 className="header-brand-title">CallTracker</h1>
        <p className="header-brand-subtitle">Tactical Command Interface</p>
      </div>
    </header>
  );
};

export default HeaderBrand;